<template>
  <div class="payout payroll">
    <table-payroll></table-payroll>
  </div>
</template>
<script>
import tablePayroll from "@/components/finance/table-payroll.vue";
export default {
  components: { tablePayroll }
};
</script>
